"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.withCurrency = exports.format = void 0;
var numeral_1 = __importDefault(require("numeral"));
var support_1 = require("../support");
var enums_1 = require("../support/enums");
// Register known currency ISOs.
for (var _i = 0, _a = Object.entries(support_1.currencyToSymbol); _i < _a.length; _i++) {
    var entry = _a[_i];
    numeral_1["default"].register('locale', entry[0], __assign(__assign({}, support_1.defaultLocale), entry[1]));
}
function format(value, format) {
    return numeral_1["default"](value).format(format);
}
exports.format = format;
function withCurrency(iso, closure) {
    if (iso in support_1.currencyToSymbol)
        numeral_1["default"].locale(iso);
    else
        numeral_1["default"].locale(enums_1.Currency.XXX);
    return closure();
}
exports.withCurrency = withCurrency;
